<button
    class="cmps-icon-button--no-bg"
    cmpsIconButton
    [cmpsTooltipTrigger]="_i18n._11190_VIEW_FOCUS_DETAILS | translate"
    (click)="_onClick($event)"
>
    <cmps-icon svgIcon="book-open-page-variant"></cmps-icon>
</button>
